import { useTheme } from '@fluentui/react';
import { stepIconFontSize } from './constants';

export interface IStepSeparatorProps {
    height?: string | number;
}

const separatorContainerStyles = {
    paddingLeft: `${stepIconFontSize / 2 + 2}px`,
    paddingTop: '4px',
    paddingBottom: '4px',
};

export const StepSeparator = ({ height }: IStepSeparatorProps) => {
    const { palette } = useTheme();

    const separatorStyles = {
        height: '5vh',
        width: 2,
        border: `1px solid ${palette.neutralTertiary}`,
        background: palette.neutralTertiary,
    };

    return (
        <div style={separatorContainerStyles}>
            <div style={{ ...separatorStyles, height: height ?? '5vh' }} />
        </div>
    );
};
